<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Editar autorización</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form
    [formGroup]="form"
    (ngSubmit)="saveChanges()"
  >
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <lib-deca-list-item
            [document]="document"
            [userCompanyId]="userCompanyId"
          ></lib-deca-list-item>
        </ion-col>
        <ion-col size="12">
          <ion-item
            lines="none"
            class="ion-margin-bottom"
          >
            <ion-toggle
              formControlName="hasSpecialAuthorization"
              justify="space-between"
              mode="md"
            >
              Requiere autorización especial
            </ion-toggle>
          </ion-item>

          @if (form.controls.hasSpecialAuthorization.value) {
            <ion-input
              type="text"
              formControlName="specialAuthorizationType"
              label="Autorización"
              labelPlacement="floating"
              placeholder="Identificador de la autorización"
              fill="outline"
              mode="md"
              [clearInput]="true"
              maxlength="100"
              [errorText]="errorText"
            ></ion-input>
          }

          @if (isServiceStarted) {
            <lib-deca-edit-reason [form]="form.controls.changeReason"></lib-deca-edit-reason>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="saveChanges()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            Guardar cambios
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
